module.exports = __webpack_public_path__ + "assets/tooltip.2a3178c9.svg";